<template>
  <v-container fluid grid-list-md>
    <v-toolbar class="elevation-5 mb-3" style="z-index: 1">
      <v-btn icon :to="spaces">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title v-if="$route.params.space_id">{{ form.name }}</v-toolbar-title>
      <v-toolbar-title v-else>New space</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn class="my-0" color="success" @click="save">save</v-btn>
    </v-toolbar>
    <progress-bar></progress-bar>
    <v-layout row wrap>
      <v-flex xs12 sm4>
        <v-card>
          <v-card-text>
            <div class='sl_form_title'>
              <h3>Main info</h3>
            </div>
            <v-divider class='my-2'></v-divider>
            <v-text-field v-model="form.name" :error-messages="errorMessages('name')"
                          label="Title"></v-text-field>
            <v-textarea v-model="form.description" :error-messages="errorMessages('description')"
                        label="Description"></v-textarea>
            <v-select
                label="Instance"
                :items="user.instanceUsers"
                item-text="instance.name"
                item-value="id"
                v-model="form.instance_user_id"
            />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm4>
        <v-card>
          <v-card-text>
            <div class='sl_form_title'>
              <h3>Accesses</h3>
            </div>
            <v-divider class='my-2'></v-divider>
            <sl-extended-select v-model="form.instance_users" :data="instance_users" :withOptions="true"></sl-extended-select>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import * as mixins from '@/mixins'
  import users from '@/components/sl-extended-select'
  import {mapGetters} from "vuex";

  export default {
    name: 'SpacesFormPage',
    mixins: [mixins.errors, mixins.form, mixins.preloader, mixins.user],
    data() {
      return {
        api: this.$api.spaces,
        instance_users: [],
        form: {
          name: '',
          instance_user_id: 0,
          users: []
        },
      }
    },
    computed: mapGetters(["spaces"]),
    mounted() {
      if (this.$route.params.space_id > 0) {
        this.load(this.$route.params.space_id)
      }

      this.$api.instance_users.list({unlimit: 1}).then(({data}) => {
        this.instance_users = data
      })

      this.form.instance_user_id = this.user.instanceUserIds[0]
    },
    components: {
      'sl-extended-select': users,
    },
  }
</script>
